import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { User } from "@app/models/User";
import { UserService } from "@app/services/user/user.service";
import { AppService } from "@mova/components/core";

@Component({
  selector: "app-validacion-qr",
  templateUrl: "./validacion-qr.component.html",
  styleUrls: ["./validacion-qr.component.scss"],
})
export class ValidacionQrComponent implements OnInit {
  isValid: boolean;
  txtValid: String;
  txtNoValid: String;
  isLoad: Boolean;

  private user:User;
  cdNifNie:String;
  cdMailUniversidad:String;

  constructor(private _userService:UserService, private activateRoute: ActivatedRoute,
    private router:Router, private _appService: AppService) {
    this.isLoad = false;
  }

  ngOnInit(): void {
    let cdNifNie = this.activateRoute.snapshot.params['cdNifNie'];
    let cdMailUniversidad = this.activateRoute.snapshot.params['cdMailUniversidad'];

    this._userService.verificarCarnet(cdNifNie, cdMailUniversidad).subscribe((res:any) => {
      this.user = res.data.data;
      this.isValid = true;
      this.txtValid = "El Carnet Universitario Digital asociado al NIF/Pasaporte <strong>"+this.user.cdNifNie+"</strong> tiene fecha de validez hasta el <strong>"+new Date(this.user.carnetDTO.fcValidez).toLocaleDateString('es-ES')+"</strong>";
      this.isLoad = true;
    }, (error) => {
      this.isValid = false;
      this.isLoad = true;
      this.txtNoValid = error.error.localizedMessage; // Aquí asignamos el mensaje de error real
    });
  }
}
